import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { LoadingService } from './core/loading/loading.service';

@Component({
  selector: 'app-root',
  imports: [AsyncPipe, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  protected title = 'ilasy-front-v2';
  protected readonly loading = inject(LoadingService);
  protected readonly loading$ = this.loading.loading$;

  constructor() {}
}
